import moment from 'moment'

const FORMAT = 'HH:mm'

export function formatDateStringHHmm(dateString: string) {
  if (!dateString) {
    return ''
  }
  return moment(dateString).format(FORMAT)
}